import React, { useState } from "react";
import SheetOrDialog from "../ui/SheetOrDialog";
import { MAX_TASK_LENGTH } from "./taskSummary";

function Body({ task, onSave, onBreakDown, onDelete }) {
  const [text, setText] = useState(task.text);
  const trimmed = text.trim();
  const canSave = trimmed.length > 0 && trimmed.length <= MAX_TASK_LENGTH;
  return (
    <div className="tk-edit">
      <h2 className="tk-edit-title">Edit task</h2>
      <label className="tk-edit-label" htmlFor="tk-edit-input">
        What needs doing
      </label>
      <input
        id="tk-edit-input"
        className="tk-edit-input"
        type="text"
        value={text}
        maxLength={MAX_TASK_LENGTH}
        onChange={(e) => setText(e.target.value)}
        autoComplete="off"
      />
      <button type="button" className="tk-btn tk-btn--primary" disabled={!canSave} onClick={() => onBreakDown(trimmed)}>
        Break this down with Rigby
      </button>
      <button type="button" className="tk-btn" disabled={!canSave} onClick={() => onSave(trimmed)}>
        Save
      </button>
      <button type="button" className="tk-btn tk-btn--danger" onClick={onDelete}>
        Delete task
      </button>
    </div>
  );
}

// Edit sheet for one task (a dialog on wide screens). Keyed by task so the text starts fresh each time.
export default function TaskEditSheet({ task, onClose, onSave, onBreakDown, onDelete }) {
  return (
    <SheetOrDialog open={!!task} onClose={onClose} label="Edit task">
      {task ? (
        <Body key={task.id} task={task} onSave={onSave} onBreakDown={onBreakDown} onDelete={onDelete} />
      ) : null}
    </SheetOrDialog>
  );
}
